export default "__VITE_ASSET__CSXp8Gik__"